import svgPaths from "./svg-m4g8kvd4nu";

export default function Moeda() {
  return (
    <div className="relative size-full" data-name="moeda">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 18 19">
        <g id="moeda">
          <g id="Rectangle"></g>
          <path d={svgPaths.p30ced600} fill="var(--fill-0, #FDE63E)" id="Coin" stroke="var(--stroke-0, black)" />
          <path d={svgPaths.pd60a700} fill="var(--fill-0, #F7BE20)" id="ICO-Creditos" stroke="var(--stroke-0, #EDA909)" />
        </g>
      </svg>
    </div>
  );
}